var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-icon-plus-call-action"},[_c(_vm.componentAction,_vm._b({tag:"Component",staticClass:"link",on:{"click":function($event){return _vm.$emit('click')}}},'Component',_vm.$attrs,false),[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-plus"})]),_c('span',{staticClass:"text"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }